import { render, staticRenderFns } from "./Servicios.vue?vue&type=template&id=ddc04524&scoped=true"
import script from "./Servicios.vue?vue&type=script&lang=js"
export * from "./Servicios.vue?vue&type=script&lang=js"
import style0 from "./Servicios.vue?vue&type=style&index=0&id=ddc04524&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddc04524",
  null
  
)

export default component.exports